import { isEmpty } from "lodash";
import dayjs from "dayjs";

export default {
	filters:{
		formatDate: (date, format = 'DD/MM/YYYY hh:mm:ss A') => {
			if (!date) return null;

			return dayjs(date).format(format);
		},
		humanFileSize: function (num) {
			if (typeof num !== 'number' || isNaN(num)) {
				throw new TypeError('Expected a number');
			}

			var exponent;
			var unit;
			var neg = num < 0;
			var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

			if (neg) {
				num = -num;
			}

			if (num < 1) {
				return (neg ? '-' : '') + num + ' B';
			}

			exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1);
			num = (num / Math.pow(1000, exponent)).toFixed(0) * 1;
			unit = units[exponent];

			return (neg ? '-' : '') + num + ' ' + unit;
		}
	},

	methods: {
		getItemName: (file) => {
			if(isEmpty(file)){
				return false;
			}

			return file.name;
		},

		isImage: (file) => {

			if(isEmpty(file)){
				return false;
			}

			return file.mimeType.indexOf('image') !== -1;
		},

		isVideo: (file) => {

			if(isEmpty(file)){
				return false;
			}

			return file.mimeType.indexOf('video') !== -1;
		},


		isFile: (file) => {
			return !isEmpty(file);
		},

		isFolder: (file) => {

			if(isEmpty(file)){
				return false;
			}

			return (file.mimeType === 'folder');
		},

		fileManagerNotify: (notices, type = 'info', time = 4000) => {

			if (typeof notices === 'object') {
				notices.forEach(function(notice) {
					window.eventHub.$emit('toast-notification', notice, type, time);
				});
				return;
			}
			window.eventHub.$emit('toast-notification', notices, type, time);
		},
	}
};
